<div class="language-drop-container" ngbDropdown placement="left">
  <button ngbDropdownToggle class="btn language-drop-menu" href="javascript: void(0);" data-toggle="dropdown"
    aria-haspopup="true" aria-expanded="false" style="border-left: 0;">
    <div class="language-selector">
      <!-- <i class="fa fa-circle profile-status-ico" aria-hidden="true"></i> -->
      <span class="language-selector-text">{{'shared.headerNavigation.language' | translate}}:</span>
      <div class="language-ico country__flag country__{{returnFlag(languageService.selectedLanguage)}}"></div>
    </div>
    <i class="fa fa-chevron-down"></i>
  </button>

  <div ngbDropdownMenu class="language-dropdown">
    <ul *ngFor="let language of languagesAvailable">
      <li ngbDropdownToggle (click)="setLanguage(language)">
        <div class="language-selector-menu">
          <div class="language-ico country__flag country__{{returnFlag(language)}}"></div>
          <span class="language-selector-text">{{'shared.headerNavigation.'+language |
            translate}}</span>
        </div>
      </li>

    </ul>
  </div>
</div>
